import { queryKeys, USER_DATA_STALE_TIME } from '@/lib/queryClient';
import { fetchPurchasedCoursesCategory } from '@/supabase/services/purchasedCourses';
import { queryOptions } from '@tanstack/react-query';

export function purchasedCoursesCategoryQueryOptions(userId: string | null) {
  return queryOptions({
    queryKey: queryKeys.purchasedCourses.category(userId),
    queryFn: () => fetchPurchasedCoursesCategory(userId),
    staleTime: USER_DATA_STALE_TIME,
    enabled: !!userId,
  });
}
